// Reine Helfer-Funktionen für den QuestionRenderer (ohne Komponenten-State).
// Ausgelagert, um die Hauptkomponente schlanker und übersichtlicher zu halten.

export interface AttachmentFile {
  originalName: string;
  filePath: string;
  size: number;
  mimeType: string;
}

/** Formatiert eine Byte-Größe in eine menschenlesbare Einheit (z. B. "1.5 MB"). */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

/** Liefert den anzuzeigenden Dateinamen (unterstützt altes und neues Attachment-Format). */
export function getFileName(attachment: string | AttachmentFile): string {
  // Neues Format mit originalName
  if (typeof attachment === 'object' && attachment.originalName) {
    return attachment.originalName;
  }
  // Altes Format - aus dem Dateipfad extrahieren
  const filePath = typeof attachment === 'object' ? attachment.filePath : attachment;
  return filePath.split('\\').pop()?.split('/').pop() || filePath;
}

/** Liefert den Originaldateinamen (für das Löschen von Anhängen). */
export function getOriginalFileName(attachment: string | AttachmentFile): string {
  if (typeof attachment === 'object' && attachment.originalName) {
    return attachment.originalName;
  }
  const filePath = typeof attachment === 'object' ? attachment.filePath : attachment;
  return filePath.split('\\').pop()?.split('/').pop() || filePath;
}
